// 액션버튼그룹 위치 관련 상수
export const BUTTON_POSITION_CONFIG = {
  TRANSFORMER_OFFSET_BELOW: 45, // transformer 아래쪽 경계에서의 거리
  TRANSFORMER_OFFSET_ABOVE: 75, // transformer 위쪽 경계에서의 거리
  CENTER_TOLERANCE: 50, // balloon 중앙 근처 허용 범위
  BELOW_THRESHOLD: 20, // shape 아래쪽 판단 기준
  SCREEN_MARGIN: 10, // 화면 경계에서의 여백
} as const

// TRIPOD 관련 상수
export const TRIPOD_CONSTANTS = {
  TRANSFORMER_HIT_STROKE_WIDTH: 20,
  MAIN_AXIS_HIT_WIDTH: 20,
  BUTTON_OFFSET: 15, // 버튼과 주축선/startPoint 사이의 거리
  DIAGONAL_OFFSET_RATIO: Math.cos(Math.PI / 4), // 45도 대각선 오프셋 비율
  MIN_SAFE_DISTANCE: 15, // startPoint들과의 최소 안전 거리
  MIN_START_POINTS: 2, // 최소 startPoint 개수
  PLUS_BUTTON_OFFSET: 30, // + 버튼 클릭 시 새 startPoint 간격
} as const

// Canvas 관련 상수
export const CANVAS_CONSTANTS = {
  HOVER_STROKE_WIDTH_INCREASE: 2, // hover 시 strokeWidth 증가량
  HIT_RADIUS_PADDING: 6, // hit 영역 padding
} as const
